import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { selectUser } from '../../reducers';
import { map } from 'rxjs';
import { User } from '../../models/core.models';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { TranslateService } from '@ngx-translate/core';

interface WelcomeItem {
  title: string;
  type: string;
  imagePath: string;
  path?: string;
  demoTime?: {
    icon: IconProp;
    time: string;
  };
}

@Component({
    selector: 'app-welcome-screen',
    templateUrl: './welcome-screen.component.html',
    styleUrls: ['./welcome-screen.component.scss'],
    standalone: false
})
export class WelcomeScreenComponent {
  user: User;
  onboardings: WelcomeItem[] = [
    {
      title: this.translateService.instant(
        'welcome-screen.title.product-overview',
      ),
      type: 'Product Demo',
      imagePath: './assets/img/intro/Product Demo.png',
      demoTime: {
        icon: ['far', 'circle-play'],
        time: '4:40',
      },
    },
    {
      title: this.translateService.instant('welcome-screen.title.onboarding'),
      type: 'Product Walkthrough',
      imagePath: './assets/img/intro/Onboarding.png',
    },
    {
      title: this.translateService.instant('welcome-screen.title.tutorials'),
      type: 'Product Waltkthrough',
      imagePath: './assets/img/intro/Tutorials.png',
    },
    {
      title: this.translateService.instant(
        'welcome-screen.title.use-cases-guides',
      ),
      type: 'Product Walkthrough',
      imagePath: './assets/img/intro/Documents.png',
    },
  ];
  getStarted: WelcomeItem[] = [
    {
      title: this.translateService.instant(
        'welcome-screen.title.create-workspace',
      ),
      type: 'Geting Started',
      imagePath: './assets/img/intro/Product Demo (1).png',
    },
  ];

  constructor(
    private store: Store<AppState>,
    private translateService: TranslateService,
  ) {
    this.store
      .select(selectUser)
      .pipe(
        map((user) => {
          this.user = user;
          // console.log(this.user);
        }),
      )
      .subscribe();
  }
}
